import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { RenameProjectRequest } from './rename-project-request.model';

@Service()
export class ProjectManagementDataService {
  private readonly http = inject(HttpService);

  async renameProjectAsync(projectId: string, name: string): Promise<void> {
    const request: RenameProjectRequest = { Name: name };
    await this.http.patchObjectAsync<RenameProjectRequest, void>(`projects/${projectId}/name`, request);
  }

  async activateProjectAsync(projectId: string): Promise<void> {
    await this.http.patchObjectAsync<null, void>(`projects/${projectId}/activate`, null);
  }

  async deactivateProjectAsync(projectId: string): Promise<void> {
    await this.http.patchObjectAsync<null, void>(`projects/${projectId}/deactivate`, null);
  }

  async deleteProjectAsync(projectId: string): Promise<void> {
    await this.http.deleteAsync<void>(`projects/${projectId}`);
  }
}
